import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        width: "100%",
        borderRadius: 16,
        position: "relative"
      },
      "& .MuiDialogContent-root": {
        marginTop: 8,
        padding: "40px 24px",
        textAlign: "center"
      }
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 4,
      "& p": {
        margin: 0
      }
    },
    description: {
      fontSize: "14px",
      color: "#FF2600",
      fontWeight: 400
    },
    titleHeader: {
      fontSize: "24px",
      color: "#000000",
      fontWeight: 700,
      marginTop: "16px !important"
    }
  }),
  { name: "DialogWaitingConfirm" }
);

export default useStyles;
